import autoAPi from './autoApi'; // 常用api
import baseCommon from './baseCommon'; // 公共api

export default {
    autoAPi,
    baseCommon
}
